import { Component, Input } from "@angular/core";
import { GetCustomTypeText } from "src/app/shared/data/product-types";

@Component({
  selector: 'asset-type-renderer',
  template: `
    <span>
      {{ getCustomTypeText(rowData?.ProductTypeId) }}
    </span>
  `,
  standalone: true,
})
export class AssetTypeRenderer {
  @Input() rowData: any;

  public getCustomTypeText = GetCustomTypeText;


}